// Animation-related constants

// Animation text classes
export const animateTextClasses = {
  root: 'animate-text-root',
  lines: 'animate-text-lines',
  line: 'animate-text-line',
  word: 'animate-text-word',
  char: 'animate-text-char',
  space: 'animate-text-space',
  srOnly: 'sr-only',
};

// Scroll progress classes
export const scrollProgressClasses = {
  circular: 'scroll-progress-circular',
  linear: 'scroll-progress-linear',
};

// Animate border classes
export const animateBorderClasses = {
  root: 'border-animation-root',
  primaryBorder: 'border-animation-primary',
  secondaryBorder: 'border-animation-secondary',
  svgWrapper: 'border-animation-svg-wrapper',
  movingShape: 'border-animation-moving-shape',
};
